import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Popovers from "@material-ui/core/Popover";
import "./Popover.scss";

const useStyles = makeStyles(() => ({
  box: {
    width: "300px",
  },
}));

const Popover = (props) => {
  const { id, open, anchorEl, anchorOrigin, transformOrigin, content, height, width } = props;
  const classes = useStyles();

  const drawerContent = <div className={classes.box} style={{height: height, width: width}}>{content}</div>;
  return (
    <span className="filter-popover">
      <Popovers
        id={id}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        disableEnforceFocus={true}
      >
        {drawerContent}
      </Popovers>
    </span>
  );
};

Popover.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool.isRequired,
  anchorOrigin: PropTypes.object.isRequired,
  anchorEl: PropTypes.object,
  transformOrigin: PropTypes.object.isRequired,
  content: PropTypes.node.isRequired,
  height: PropTypes.string,
  width: PropTypes.string
};
export default Popover;
